type TCreateBundle = {
	bundle: object;
	translations: Record<string, string>;
	enablePseudo?: boolean;
};

export const createi18nTranslationBundle = ({ bundle, translations, enablePseudo = false }: TCreateBundle) => {
	const translationBundle: Record<string, string | object> = {};
	Object.entries(bundle).forEach(([key, value]) => {
		if (typeof value === 'string') {
			if (enablePseudo) {
				translationBundle[key] = `上${value}下`;
			} else {
				translationBundle[key] = translations[value] || value;
			}
		} else {
			translationBundle[key] = createi18nTranslationBundle({
				bundle: value,
				translations,
				enablePseudo,
			});
		}
	});
	return translationBundle;
};
